import { atom, selector } from 'recoil'

import type {
  ListItem,
  PaginationState,
  UtilsState,
} from 'Pages/UnsubscriptionCampaignsList/types'

export const resultsState = atom<ListItem[]>({
  key: 'unsubscriptionCampaignsList_resultsState',
  default: [],
})

export const paginationState = atom<PaginationState>({
  key: 'unsubscriptionCampaignsList_paginationState',
  default: {
    pageNumber: 1,
    pageSize: 10,
    totalItems: 0,
    orderBy: 'LastModifiedDate',
    orderDescending: true,
    loading: false,
  },
})

export const emptyStateState = selector<boolean>({
  key: 'unsubscriptionCampaignsList_emptyStateState',
  get: ({ get }) => {
    const items = get(resultsState)

    return items.length === 0
  },
})

export const utilsState = atom<UtilsState>({
  key: 'unsubscriptionCampaignsList_utilsState',
  default: {
    canCreate: false,
  },
})
